export default __webpack_public_path__ + "static/media/padlock.5f3200e8.png";